import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { RequestService } from '../request.service';
import { RequestConsentDialogData, RequestConsentDialogReturnData } from './request-consent-dialog.types';

/*
// @todo THINGS TO DO
When opened, set ProjectId (with internal function), trust me on this one
Put it on "Big Case List", should be good
When saved, check from caller if it is the same ApartmentId before adding to list
Apartment + Field Selectors could be on the same line
*/

@Component({
  selector: 'apex-request-consent-dialog',
  templateUrl: 'request-consent-dialog.component.html',
})
export class RequestConsentDialogComponent implements OnInit, OnDestroy {
  subs = new Subscription();
  consentToArticle = false;
  requiresExplicitConsent = false;

  constructor(
    public dialogRef: MatDialogRef<RequestConsentDialogComponent, RequestConsentDialogReturnData>,
    @Inject(MAT_DIALOG_DATA) public data: RequestConsentDialogData,
    private requestService: RequestService,
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass(['apex-fullscreen-dialog', 'phone']);

    this.requiresExplicitConsent = this.data.requiresExplicitConsent === true;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  consent(): void {
    this.dialogRef.close({ consented: true });
  }
}
